import { fetchData } from '@/utils/fetch'

export const retrieveFeaturedList = (data) => {
  return fetchData('/appb/alibaba-common/featured/productList', {
    method: 'post',
    body: JSON.stringify(data)
  })
}
